import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { NgSelectModule } from '@ng-select/ng-select';
import { TextMaskModule } from 'angular2-text-mask';
import { AgmCoreModule } from '@agm/core';

import { ErrorsModule } from '@app/errors/errors.module';
import { CanDeactivateGuard } from '@app/shared/guards';
import { LocationService } from '@app/shared/services';
import { UspsService } from '@app/shared/services';
import { Daterangepicker } from 'ng2-daterangepicker';

import {
  SwitchComponent,
  CustomMapComponent,
  CustomInputComponent,
  CustomOptionalInputComponent,
  CustomInputMaskComponent,
  CustomRadioComponent,
  CustomRadioTypeComponent,
  CustomSelectComponent,
  CustomInputNumberComponent,
  CustomInputEmailComponent,
  CustomInputTelComponent,
  CustomTextareaComponent,
  CustomDateComponent,
  AddressValidationComponent,
  AutocompleteComponent,
  CustomDateInputComponent,
  CustomDateTodayComponent,
  CustomDateModalComponent,
  CustomPlannedDateInputComponent,
  CustomDateModalTwoComponent
} from '@app/shared/controls';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { ContactUsService } from './services/contact-us.service';

const COMPONENTS = [
  CustomMapComponent,
  CustomInputComponent,
  CustomOptionalInputComponent,
  CustomInputMaskComponent,
  CustomRadioComponent,
  CustomRadioTypeComponent,
  CustomSelectComponent,
  CustomInputNumberComponent,
  CustomInputEmailComponent,
  CustomInputTelComponent,
  CustomTextareaComponent,
  CustomDateComponent,
  CustomDateInputComponent,
  CustomDateModalComponent,
  CustomDateTodayComponent,
  CustomPlannedDateInputComponent,
  SwitchComponent,
  AddressValidationComponent,
  AutocompleteComponent,
  CustomDateModalTwoComponent
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorsModule,
    DropDownListModule,
    NgSelectModule,
    TextMaskModule,
    Daterangepicker,
    AgmCoreModule.forRoot({ apiKey: 'AIzaSyB07y6RxtlvdnrzAnBH-N0oPg2pjuyPpgo', libraries: ['places'] }),
  ],
  declarations: [
    COMPONENTS
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorsModule,
    COMPONENTS,
    NgSelectModule,
    Daterangepicker,
    TextMaskModule
  ],
  providers: [
    DatePipe,
    LocationService,
    UspsService,
    CanDeactivateGuard,
    ContactUsService
  ]
})
export class SharedModule { }
